// src/get-native-event.ts
function getNativeEvent(event) {
  return event.nativeEvent ?? event;
}

export {
  getNativeEvent
};
